import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { FaTimes } from "react-icons/fa";
import "./BrowsingModal.css";

const BrowsingModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="browsing-modal">
      <DialogTitle className="bm-modal-title">Recommended Browsing Parameters:</DialogTitle>
      <DialogContent className="bm-modal-content">
        <div className="bm-modal-body">
          <p><strong>Browser:</strong> Chrome</p>
          <p><strong>Aspect Ratio:</strong> 16:9</p>
          <p><strong>Resolution:</strong> 1920:1080</p>
          <p><strong>Mode:</strong> Landscape</p>
          <p><strong>Zoom:</strong> 100%</p>
        </div>
        <div className="bm-modal-footer">
          <p>Lacewood Consulting Pvt. Ltd.<br />01 Jan 2025<br />Ver: 1.1</p>
          <IconButton className="bm-close-button" onClick={onClose}>
            <FaTimes />
          </IconButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BrowsingModal;
